import { render } from "./Store.vue?vue&type=template&id=60d5e9ae"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Store.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d5e9ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d5e9ae', __exports__)) {
    api.reload('60d5e9ae', __exports__)
  }
  
  module.hot.accept("./Store.vue?vue&type=template&id=60d5e9ae", () => {
    api.rerender('60d5e9ae', render)
  })

}


export default __exports__